import packageJson from "../../package.json";

export const environment = {
  version: packageJson.version,
  configServiceUrl: "https://public-api-gateway-staging-atmk2xykxq-ew.a.run.app/api/v1/configuration",
};
